module.exports = __webpack_public_path__ + "img/BlueGradient.ea000f72.png";